<template>
  <div class="animated fadeIn">
    <OTOrderDialog EntityType="Order">
      <div slot="header">
        <h2>Test</h2>
      </div>
      <div slot="details">
        <!-- <div>{{ mySelected.Title }}</div>
              <div>{{ mySelected.Email1 }}</div> -->
      </div>
      <span slot="entityType">Sponsor</span>
    </OTOrderDialog>
    <b-row>
      <b-col lg="6">
        <b-form-group>
          <b-input-group>
            <b-form-input
              type="text"
              placeholder="Search"
              @keyup="filterList"
              v-model="searchString"
            />

            <b-input-group-append>
              <b-input-group-text>
                <i
                  class="fa fa-times appendIcon clickIcon"
                  @click="resetSearch"
                ></i>
              </b-input-group-text>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col lg="3">
        <b-form-radio-group
          class="mr-3"
          id="radiosBtn"
          buttons
          button-variant="outline-primary"
          v-model="filterStatus"
          name="radiosBtn"
          @change.native="preprocessFilter"
        >
          <b-form-radio class="mx-0" value="pending">Pending</b-form-radio>
          <b-form-radio class="mx-0" value="all">Show All</b-form-radio>
        </b-form-radio-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12">&nbsp;</b-col>
    </b-row>

    <b-row>
      <b-col sm="12">
        <b-table
          @row-clicked="myRowClickHandler"
          :items="filteredOrders"
          :fields="fields"
          hover
          small
          fixed
          caption
          selectable
          select-mode="single"
          responsive="sm"
          selectedVariant="success"
          :current-page="currentPage"
          :per-page="perPage"
        >
          <template slot="Functions" slot-scope="data">
            <i
              v-b-tooltip
              title="Delete"
              class="fa fa-trash"
              v-b-modal.modal-2
              @click="SetItemToDelete(data.item)"
            ></i>
          </template>
        </b-table>

        <nav v-show="isNavVisible">
          <b-pagination
            :per-page="perPage"
            :total-rows="totalRows"
            v-model="currentPage"
            prev-text="Prev"
            next-text="Next"
            hide-goto-end-buttons
          />
        </nav>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import cTable from "@/views/base/Table.vue";
import OTOrderDialog from "@/views/orders/OneTimeOrderModal.vue";

export default {
  name: "MyOTOrderList",
  data: () => {
    return {
      fields: [
        {
          key: "OrderID",
          label: "Invoice Number",
          sortable: true
        },
        {
          key: "CustomerID",
          label: "Customer ID",
          sortable: true
        },
        {
          key: "Quantity",
          label: "Quantity",
          sortable: true
        },
        {
          key: "ProcessDate",
          label: "Processed On",
          sortable: true
        },
        {
          key: "TrackingNumber",
          label: "Tracking Number",
          sortable: true
        }
      ],
      mySelected: {},
      currentPage: 1,
      perPage: 50,
      filteredOrders: [],
      filterStatus: "all",
      searchString: ""
    };
  },
  props: {},
  components: {
    cTable,
    OTOrderDialog
  },
  created() {
    this.$store.dispatch("order/getOTOrders").then(this.filterList());
    //.then((this.filteredOrders = this.$store.state.order.one_time_orders));
  },
  mounted() {
    // this.$store
    //   .dispatch("order/getOTOrders")
    //   .then((this.filteredOrders = this.$store.state.order.one_time_orders));
  },
  computed: {
    ...mapGetters({
      totalRows: "order/OrderCount"
    }),
    //totalRows: this.filteredOrders.length(),
    isNavVisible: function() {
      return this.totalRows > this.perPage;
    },
    ...mapState(["order", "notification"]),
    ...mapActions("notification", ["add", "remove"])
  },
  updated() {
    this.incrementCount;
  },
  methods: {
    filterList: function() {
      //alert(this.$store.state.order.one_time_orders.length);
      if (this.filterStatus === "pending") {
        this.filteredOrders = this.$store.state.order.one_time_orders.filter(
          ord => ord.TrackingNumber === "Pending"
        );
      } else {
        this.filteredOrders = this.$store.state.order.one_time_orders;
      }

      this.filteredOrders = this.filteredOrders.filter(
        ord =>
          ord.OrderID.toLowerCase().indexOf(this.searchString.toLowerCase()) >
            -1 ||
          ord.CustomerID.toLowerCase().indexOf(
            this.searchString.toLowerCase()
          ) > -1
      );
    },
    preprocessFilter: function(event) {
      this.filterList();
    },
    resetSearch: function() {
      this.searchString = "";
      this.filterList();
    },
    myRowClickHandler(record, index) {
      // 'record' will be the row data from items
      // `index` will be the visible row number (available in the v-model 'shownItems')
      this.$store.dispatch("order/loadOrderEdit", record.OrderID).then(() => {
        //this.$router.push({ name: "OneTimeOrder" });
        this.$bvModal.show("modal-otorder");
      });
    },
    SetItemToDelete(object) {
      this.mySelected = object;
    }

    // totalRows() {
    //   if (this.filteredOrders) {
    //     return this.filteredOrders.length;
    //   } else {
    //     return this.$store.state.order.one_time_orders.length;
    //   }
    // }
  },
  watch: {
    "$store.state.order.one_time_orders": function() {
      //console.log(this.$store.state.order.one_time_orders);
      this.filterList();
    }
  }
};
</script>

<style scoped>
.my-tbl-function {
  width: 10% !important;
  color: red;
}
</style>
